import { Listbox } from '@headlessui/react';
import { OddsTypeIndicator } from '@library/components/OddsTypeIndicator';
import type { SelectOption } from '@library/types/utils';
import checkedIcon from '@library/assets/images/icons/checked-icon.svg';
import { classNames } from '@library/utils';

export interface SelectOptionsProps<T extends string> {
  options: Array<SelectOption<T>>;
  smallSize: boolean;
  testId?: string;
}

export const SelectOptions = <T extends string>({
  options,
  smallSize,
  testId = 'select-option'
}: SelectOptionsProps<T>) => {
  return options.map((option) => {
    const { icon, key, name, oddsType } = option;
    return (
      <Listbox.Option
        className={({ selected }) =>
          classNames(
            'hover:bg-soFresh-140 text-soClean-100 relative flex w-full cursor-default select-none py-2 pl-3 pr-4',
            selected ? 'bg-soFresh-140' : 'text-soClean-100'
          )
        }
        key={key}
        value={option}
        title={name}
        data-testid={`${testId}-option-${key}`}
      >
        {({ selected }) => (
          <div className="flex w-full justify-between">
            <span
              className={classNames(
                'mr-6 inline-flex gap-1 truncate',
                selected ? 'font-medium' : 'font-normal',
                smallSize ? 'text-xs' : 'text-base'
              )}
            >
              {icon}
              {name}
              {oddsType && (
                <OddsTypeIndicator
                  oddsType={oddsType}
                  className="flex self-center pl-1"
                  iconClassName="size-3"
                />
              )}
            </span>
            {selected && <img className="" src={checkedIcon} alt="Selected" />}
          </div>
        )}
      </Listbox.Option>
    );
  });
};
